import { zRequiredString, zDecimal } from "@goodfill/domain-properties-zod-validators";
import { z } from "zod";

export const cdRatesSchema = z.object({
  cdRates: z.array(
    z.object({
      maturity: zRequiredString(),
      rate: zDecimal(),
    }),
  ),
});

export type CdRates = z.infer<typeof cdRatesSchema>;
